<template>
  <div
    class="modal fade"
    id="feedModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.FEE000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="feed-modal-content">
            <div class="form-group">
              <div class="col-md-10">
                <textarea
                  class="form-control"
                  id="inputNewFeedPost"
                  rows="3"
                  maxlength="1000"
                  :placeholder="lang.FEE001"
                  v-model="newFeedPostContent"
                />
              </div>
              <div class="col-md-2">
                <button
                  class="btn btn-raised dialog-btn-primary"
                  @click="addFeedPost()"
                  :disabled="!newFeedPostContent"
                >
                  {{ lang.FEE002 }}
                </button>
              </div>
            </div>

            <div v-if="currentFeedPosts.length < 1">{{ lang.FEE003 }}</div>
            <table class="table" v-else>
              <thead>
                <tr>
                  <th class="text-left" style="width: 30%">
                    {{ lang.FEE004 }}
                  </th>
                  <th class="text-left" style="width: 70%">
                    {{ lang.FEE005 }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="post in currentFeedPosts" :key="post.FeedPostGuid">
                  <td class="text-left">
                    <b
                      >{{ post.FeedPostCreatedBy.Lastname }},
                      {{ post.FeedPostCreatedBy.Firstname }}</b
                    >
                    -
                    <span
                      :class="{
                        'text-red text-bold':
                          post.FeedPostCreatedBy.Username ===
                          globals.currentUserName,
                      }"
                      >{{ post.FeedPostCreatedBy.Username }}</span
                    >
                    <br />
                    <span class="post-creation-timestamp">{{
                      globals.getLocalizedDateTimeFromUtcIsoTimestamp(
                        post.FeedPostCreatedAt
                      )
                    }}</span>
                  </td>
                  <td
                    class="text-left"
                    v-html="addContentHighlighting(post.Content)"
                  ></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.FEE006 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedModal",
  data() {
    return {
      title: "",
      newFeedPostContent: "",
      availableFeeds: [],
      currentFeedConfig: {},
      currentFeedPosts: [],
      lang: {
        FEE000: "Feed",
        FEE001: "New message...",
        FEE002: "Send",
        FEE003: "No messages available yet.",
        FEE004: "Info",
        FEE005: "Message",
        FEE006: "Close",
        FEE007: "Available feeds request failed",
        FEE008: "Feed data request failed",
        FEE009: "Message sent",
        FEE010: "Sending failed",
      },
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getAvailableFeeds();

    $("#feedModal").on("hidden.bs.modal", (e) => {
      this.globals.$emit(
        "feedModalClosed",
        this.currentFeedConfig.ItemGuid,
        this.currentFeedPosts
      );
    });

    this.globals.$off("openFeedModal");
    this.globals.$on("openFeedModal", (config) => {
      this.currentFeedConfig = config;
      this.getFeedPosts();
      $("#feedModal").modal("show");
    });
    this.globals.$off("closeFeedModal");
    this.globals.$on("closeFeedModal", () => {
      $("#feedModal").modal("hide");
    });

    this.globals.$off("requestFeedPosts");
    this.globals.$on("requestFeedPosts", (config) => {
      this.getFeedPosts(config);
    });
  },
  methods: {
    addContentHighlighting(content) {
      let userHighlightString = `@${this.globals.currentUserName}`;

      let result = content.replace(
        userHighlightString,
        `<span class="text-red text-bold">${userHighlightString}</span>`
      );
      return result;
    },
    getCurrentFeedGuid(config) {
      let currentFeed = _.find(
        this.availableFeeds,
        (f) => f.FeedType === config.FeedType && f.FeedName === config.FeedName
      );
      return currentFeed && currentFeed.FeedGuid;
    },
    getAvailableFeeds() {
      $.ajax({
        method: "GET",
        url: `api/Feed/Available`,
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.availableFeeds = [];
          if (data[0]) this.availableFeeds = data;
        },
        error: (error) => {
          console.error("Error on GET in getAvailableFeeds()");
          this.globals.showErrorSnackbar(this.lang.FEE007);
        },
      });
    },
    getFeedPosts(config) {
      let cfg = config || this.currentFeedConfig;
      if (!cfg.ItemGuid) return;

      let currentFeedGuid = this.getCurrentFeedGuid(cfg);
      if (!currentFeedGuid) return;

      let query = `api/Feed/${currentFeedGuid}/Posts/${cfg.ItemGuid}`;
      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }

          this.currentFeedPosts = data[0]
            ? _.orderBy(data, ["FeedPostCreatedAt"], ["desc"])
            : [];

          this.globals.$emit(
            "feedPostsReceived",
            cfg.ItemGuid,
            cfg.FeedName,
            this.currentFeedPosts
          );
        },
        error: (error) => {
          console.error("Error on GET in getFeedPosts()");
          this.globals.showErrorSnackbar(this.lang.FEE008);
          this.currentFeedPosts = [];
          this.globals.$emit(
            "feedPostsReceived",
            cfg.ItemGuid,
            cfg.FeedName,
            []
          );
        },
      });
    },
    addFeedPost() {
      let cfg = this.currentFeedConfig;
      if (!cfg.ItemGuid || !this.newFeedPostContent) return;

      let currentFeedGuid = this.getCurrentFeedGuid(cfg);
      if (!currentFeedGuid) return;

      let sendData = {
        Content: this.newFeedPostContent,
      };
      let query = `api/Feed/${currentFeedGuid}/Posts/${cfg.ItemGuid}`;

      $.ajax({
        method: "POST",
        url: query,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.getFeedPosts();
          this.newFeedPostContent = "";
          this.globals.showSuccessSnackbar(this.lang.FEE009);
        },
        error: (error) => {
          console.error("Error on POST in addFeedPost()");
          this.globals.showErrorSnackbar(this.lang.FEE010);
        },
      });
    },
  },
};
</script>

<style scoped>
.modal-body {
  padding: 10px;
}
.feed-modal-content {
  max-height: calc(100vh - 175px);
  overflow: auto;
}

.modal-body .form-group {
  margin-bottom: 30px;
}
.post-creation-timestamp {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// FeedModal.vue?7a76e8d0